import script from "./resetpassword.vue?vue&type=script&setup=true&lang=js"
export * from "./resetpassword.vue?vue&type=script&setup=true&lang=js"

import "./resetpassword.vue?vue&type=style&index=0&id=828d2e82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-828d2e82"]])

export default __exports__